var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "gallery-fade" } }, [
    _vm.visible
      ? _c("div", { staticClass: "chat-media-gallery-overlay" }, [
          _c("div", {
            staticClass: "gallery-backdrop",
            on: { click: _vm.tryCloseFromBackdrop },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "gallery-panel",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("div", { staticClass: "gallery-header" }, [
                _c("span", { staticClass: "gallery-counter" }, [
                  _vm._v(
                    _vm._s(_vm.currentIndex + 1) +
                      " / " +
                      _vm._s(_vm.items.length)
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "gallery-header-actions" }, [
                  _vm.showGoToMessage && _vm.canEmitGoToMessage
                    ? _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "bottom",
                              },
                              expression:
                                "{ followCursor: true, placement: 'bottom' }",
                            },
                          ],
                          staticClass: "gallery-go-message-btn",
                          attrs: {
                            type: "button",
                            content: _vm.$t("task.goToMessage"),
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.emitGoToMessage.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("my_location"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "gallery-go-message-label" },
                            [_vm._v(_vm._s(_vm.$t("task.goToMessage")))]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "gallery-close-btn",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("close"),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "gallery-body" }, [
                _c(
                  "button",
                  {
                    staticClass: "gallery-nav-btn gallery-prev",
                    attrs: { disabled: _vm.currentIndex === 0 },
                    on: { click: _vm.prev },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("chevron_left"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "gallery-media-container",
                    on: {
                      wheel: function ($event) {
                        $event.preventDefault()
                        return _vm.onWheel.apply(null, arguments)
                      },
                      mousedown: _vm.onDragStart,
                      mousemove: _vm.onDragMove,
                      mouseup: _vm.onDragEnd,
                      mouseleave: _vm.onDragEnd,
                    },
                  },
                  [
                    _vm.currentItem
                      ? [
                          _vm.imageLoading && _vm.isItemImage(_vm.currentItem)
                            ? _c("div", { staticClass: "gallery-loading" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "material-icons gallery-loading-icon",
                                  },
                                  [_vm._v("hourglass_empty")]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isItemVideo(_vm.currentItem)
                            ? _c("video", {
                                key: "vid-" + _vm.currentIndex,
                                staticClass: "gallery-video",
                                attrs: {
                                  src: _vm.currentItem.url,
                                  controls: "",
                                  autoplay: "",
                                },
                              })
                            : _vm.isItemAudio(_vm.currentItem)
                            ? _c(
                                "div",
                                {
                                  key: "aud-" + _vm.currentIndex,
                                  staticClass: "gallery-audio-panel",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "material-icons gallery-audio-panel-icon",
                                    },
                                    [_vm._v("mic")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { staticClass: "gallery-audio-panel-name" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.itemDisplayName(_vm.currentItem)
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "gallery-audio-panel-player",
                                    },
                                    [
                                      _c("audio", {
                                        staticClass: "gallery-audio",
                                        attrs: {
                                          src: _vm.currentItem.url,
                                          controls: "",
                                          preload: "auto",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm.isItemImage(_vm.currentItem)
                            ? _c("img", {
                                key:
                                  "img-" +
                                  _vm.currentIndex +
                                  "-" +
                                  _vm.galleryImageKeySuffix(_vm.currentItem),
                                ref: "galleryMainImg",
                                staticClass: "gallery-img",
                                class: {
                                  "gallery-img--hidden": _vm.imageLoading,
                                  "gallery-img--dragging": _vm.dragging,
                                },
                                style: _vm.imgTransformStyle,
                                attrs: {
                                  src: _vm.currentItem.url,
                                  "data-gallery-load-token": String(
                                    _vm.imageLoadToken
                                  ),
                                  draggable: "false",
                                },
                                on: {
                                  load: _vm.onImageLoad,
                                  error: _vm.onImageError,
                                },
                              })
                            : _c(
                                "div",
                                {
                                  key: "file-" + _vm.currentIndex,
                                  staticClass: "gallery-file-fallback",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "material-icons gallery-file-fallback-icon",
                                    },
                                    [_vm._v("insert_drive_file")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { staticClass: "gallery-file-name" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.itemDisplayName(_vm.currentItem)
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "gallery-file-download",
                                      attrs: {
                                        href: _vm.currentItem.url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        download: "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.$t("message.download")) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "gallery-nav-btn gallery-next",
                    attrs: {
                      disabled: _vm.currentIndex === _vm.items.length - 1,
                    },
                    on: { click: _vm.next },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("chevron_right"),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm.currentItem && _vm.isItemImage(_vm.currentItem)
                ? _c("div", { staticClass: "gallery-toolbar" }, [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: { placement: "top" },
                            expression: "{ placement: 'top' }",
                          },
                        ],
                        staticClass: "gallery-toolbar-btn",
                        attrs: { type: "button", content: "Zoom In" },
                        on: { click: _vm.zoomIn },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("add"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: { placement: "top" },
                            expression: "{ placement: 'top' }",
                          },
                        ],
                        staticClass: "gallery-toolbar-btn",
                        attrs: { type: "button", content: "Zoom Out" },
                        on: { click: _vm.zoomOut },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("remove"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: { placement: "top" },
                            expression: "{ placement: 'top' }",
                          },
                        ],
                        staticClass: "gallery-toolbar-btn",
                        attrs: { type: "button", content: "1:1" },
                        on: { click: _vm.zoomReset },
                      },
                      [
                        _c("span", { staticClass: "gallery-toolbar-label" }, [
                          _vm._v("1:1"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "gallery-toolbar-divider" }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: { placement: "top" },
                            expression: "{ placement: 'top' }",
                          },
                        ],
                        staticClass: "gallery-toolbar-btn",
                        attrs: { type: "button", content: "Rotate Left" },
                        on: { click: _vm.rotateLeft },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("rotate_left"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: { placement: "top" },
                            expression: "{ placement: 'top' }",
                          },
                        ],
                        staticClass: "gallery-toolbar-btn",
                        attrs: { type: "button", content: "Rotate Right" },
                        on: { click: _vm.rotateRight },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("rotate_right"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "gallery-toolbar-divider" }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: { placement: "top" },
                            expression: "{ placement: 'top' }",
                          },
                        ],
                        staticClass: "gallery-toolbar-btn",
                        attrs: { type: "button", content: "Flip Horizontal" },
                        on: { click: _vm.flipHorizontal },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("swap_horiz"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: { placement: "top" },
                            expression: "{ placement: 'top' }",
                          },
                        ],
                        staticClass: "gallery-toolbar-btn",
                        attrs: { type: "button", content: "Flip Vertical" },
                        on: { click: _vm.flipVertical },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("swap_vert"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "gallery-toolbar-divider" }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: { placement: "top" },
                            expression: "{ placement: 'top' }",
                          },
                        ],
                        staticClass: "gallery-toolbar-btn",
                        attrs: { type: "button", content: "Download" },
                        on: { click: _vm.downloadCurrent },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("file_download"),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { ref: "galleryThumbs", staticClass: "gallery-thumbnails" },
                _vm._l(_vm.visibleThumbs, function (entry) {
                  return _c(
                    "div",
                    {
                      key: entry.idx,
                      staticClass: "gallery-thumb",
                      class: {
                        active: entry.idx === _vm.currentIndex,
                        "gallery-thumb--audio": _vm.isItemAudio(entry.item),
                      },
                      on: {
                        click: function ($event) {
                          _vm.currentIndex = entry.idx
                        },
                      },
                    },
                    [
                      _vm.isItemImage(entry.item)
                        ? _c("img", {
                            attrs: { src: entry.item.url, loading: "lazy" },
                          })
                        : _vm.isItemVideo(entry.item)
                        ? _c(
                            "div",
                            { staticClass: "gallery-thumb-video-placeholder" },
                            [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("play_circle_filled"),
                              ]),
                            ]
                          )
                        : _vm.isItemAudio(entry.item)
                        ? _c(
                            "div",
                            { staticClass: "gallery-thumb-audio-card" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "material-icons gallery-thumb-audio-card-icon",
                                },
                                [_vm._v("graphic_eq")]
                              ),
                              _vm._v(" "),
                              _c("audio", {
                                staticClass: "gallery-thumb-audio-mini",
                                attrs: {
                                  src: entry.item.url,
                                  controls: "",
                                  preload: "metadata",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              }),
                            ]
                          )
                        : _c(
                            "div",
                            { staticClass: "gallery-thumb-file-placeholder" },
                            [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("insert_drive_file"),
                              ]),
                            ]
                          ),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }